<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-start>
      <v-flex xs12 text-left>
        <span style="color: #000; font-size: 20px; font-family: poppinsbold"
          >Customer List</span
        >
      </v-flex>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12 sm6 md3 pa-5>
            <v-select
              v-model="filter"
              :items="filterStatus"
              item-text="name"
              item-value="value"
              item-color="#8d8d8d"
              color="#8d8d8d"
              outlined
              dense
              label="Status"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs12>
        <v-layout wrap justify-center pt-4>
          <v-flex>
            <v-tabs
              fixed-tabs
              v-model="tabValue"
              color="#FDAC53"
              centered
              slider-color="yellow"
            >
              <v-tab v-for="item in titleArray" :key="item.value">
                {{ item.title }}
              </v-tab>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-flex> -->

      <v-flex xs12>
        <v-layout wrap>
          <v-flex v-if="customers.length > 0" xs12 pt-0 text-left>
            <!-- <span style="color: #000; font-size: 18px; font-family: poppinsbold"
              >Requests</span
            > -->
            <CustomerList
              :customerData="customers"
              :filter="filter"
              :pages="pages"
              @stepper="winStepper"
            />
          </v-flex>

          <v-flex v-else xs12 text-left pa-4>
            <!-- <span style="color: #000; font-size: 18px; font-family: poppinsbold"
              >Requests</span
            > -->
            <br />
            <span class="textField2"> No Customer Found !! </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import CustomerList from "./customerData";
export default {
  components: {
    CustomerList,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      timeout: 5000,
      msg: null,
      customers: [],
      details: [],
      panel: [],
      disabled: false,
      fromDate: new Date(),
      toDate: new Date(),
      menu1: false,
      menu2: false,
      currentPage: 1,
      pages: 0,
      filter: null,
      filterStatus: [
        { name: "All", value: null },
        { name: "Pending", value: "Pending" },
        { name: "Active", value: "Active" },
        { name: "Rejected", value: "Reject" },
      ],
      type: null,
      userList: [],
    };
  },

  beforeMount() {
    // this.getExcel();
    // this.getData();

    // if (this.dateProp != "dateWisePrograms") this.date = null;
    // this.getData();
    // this.getProgramme();
    // if (this.fromDate) {
    //   this.fromDate.setDate(this.fromDate.getDate());
    //   this.fromDate = this.fromDate.toISOString().substr(0, 10);
    // }
    // if (this.toDate) {
    //   this.toDate.setDate(this.toDate.getDate());
    //   this.toDate = this.toDate.toISOString().substr(0, 10);
    // }
    this.getData();
  },
  watch: {
    filter() {
      if (this.currentPage > 1) this.currentPage = 1;
      this.getData();
    },
    // fromDate() {
    //   if (this.fromDate == null) this.getData();
    //   this.checkDate();
    // },
    // toDate() {
    //   if (this.toDate == null) this.getData();
    //   this.checkDate();
    // },
     currentPage()
    {
      this.getData();
    }
  },
  
  methods: {
    // checkDate() {
    //   let ndate = new Date().toISOString().substr(0, 10);
    //   if (this.fromDate == ndate) {
    //   const tomorrow = new Date(this.fromDate);
    //   tomorrow.setDate(tomorrow.getDate() - 30);
    //   this.fromDate = tomorrow.toISOString().substr(0, 10);
    //   }
    //   this.getData();
    // },
    // checkDate1() {
    //   // let ndate = new Date().toISOString().substr(0, 10);
    //   // if (this.fromDate == ndate) {
    //   const tomorrow = new Date(this.fromDate);
    //   tomorrow.setDate(tomorrow.getDate() + 30);
    //   this.toDate = tomorrow.toISOString().substr(0, 10);
    //   // }
    //   this.getData();
    // },
    winStepper(windowData) {
       if(windowData.getData)
        
        {
          this.getData();
        }
        this.currentPage = windowData.currentPage;
        if (windowData.pages) this.pages = windowData.pages;
    },
    getData() {
      if (this.currentPage) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/users/list",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            role: "Customer",
            status: this.filter,
            count: 20,
            page: this.currentPage,
          },
        })
          .then((response) => {
            if (response.data.status) {
              this.customers = response.data.data;
              this.pages = response.data.pages;

              // this.excel = response.data.data;
              // this.json_data = this.excel;
              this.appLoading = false;
            } else {
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    formatDate(item) {
      var dt = new Date(item);
      // var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
  },
};
</script>
<style>
.head {
  font-family: poppinsregular;
  font-size: 14px;
}
.content {
  font-family: poppinsbold;
  font-size: 13px;
}
</style>